import { FunctionComponent } from "react";
import Home from "../pages/home";

export const Routes: Record<string, FunctionComponent<any>> = {
  "/": Home,
};
